import { Button as TomatoButton, ThemeProvider as TomatoProvider } from '@change/ds-core-ui';
import type { ButtonProps as TomatoButtonProps } from '@change/ds-core-ui';

import { Button as SunriseButton } from '@change/ds-core-ui/next';
import type { ButtonProps } from '@change/ds-core-ui/next';

import { useIsSunriseEnabled } from '../../../../../hooks/isSunriseEnabled';

export const Button = ({ children, ...props }: ButtonProps) => {
	const {
		data: { isSunriseEnabled },
	} = useIsSunriseEnabled();

	return (
		<>
			{isSunriseEnabled ? (
				<div data-qa="sunrise-provider">
					<SunriseButton {...props}>{children}</SunriseButton>
				</div>
			) : (
				<TomatoProvider data-qa="tomato-provider">
					<TomatoButton {...(props as TomatoButtonProps)}>{children}</TomatoButton>
				</TomatoProvider>
			)}
		</>
	);
};
